export const navigationPaths = Object.freeze({
    SUCHE: "/suche",
    JP_KUNDE_ANLEGEN: "/kunde/jp/:id",
    NP_KUNDE_ANLEGEN: "/kunde/np/:id",
    ANBAHNUNGSDATEN: "/anbahnung/:id",
    TARIFIERUNGSUEBERSICHT: "/anbahnung/:id/tarifierung",
    VERSICHERUNGSUMFANG: "/tarifierung/:id/versicherungsumfang",
    RISIKOORTE: "/tarifierung/:id/risikoort",
    BEREICHE: "/tarifierung/:id/risikoort/bereich",
    KALKULATION: "/kalkulation/:id",
    BU: "/betriebsunterbrechungmv/:id",
    VLR: "/versorgungslückenrechner",
    LIVE_COCKPIT: "/live-cockpit"
})